import { ServiceAlertApiClient } from '@/libs/ServiceAlertApiClient';
import { paramTypeEnum } from '@/libs/ApiClient';
import { RouteUrlList } from '@/libs/RouteList';
import type { GeneralResp } from '@/models/GeneralResp';
import type { AxiosResponse } from 'axios';

/**
 * @todo 逾時登出
 */
const IdleTimeout = (_url?: string | null): Promise<GeneralResp> => {
    const url = _url || RouteUrlList.API_IdleTimeout.path;
    const config = {
        params: { showOverlay: paramTypeEnum.false, getServiceAlert: paramTypeEnum.true }
    };
    return ServiceAlertApiClient.post(url, {}, config).then((res: AxiosResponse<GeneralResp>) => {
        return res.data;
    });
};

export default IdleTimeout;
